import { combineReducers } from 'redux';
import user from './user';
import fbuser from './fbuser';
import members from './members';
import presentation from './presentation';
import token from './token';
import campaign from './campaign';
import ad from './ad';
import adPreview from './ad.preview';
import adQc from './ad.qc';
import adComparer from './ad.comparer';
import adShare from './ad.share';
import adImport from './ad.import';

const appReducer = combineReducers({
  user,
  fbuser,
  members,
  presentation,
  ad,
  token,
  campaign,
  adPreview,
  adQc,
  adComparer,
  adShare,
  adImport
});

const rootReducer = (state, action) => {
  const returnedState = action.type === 'RESET' ? undefined : state;
  return appReducer(returnedState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js